import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import dsGoiVayApi from "service/GoiVay/dsGoiVayApi";
import { pushNotification } from "utils/notifications";
import { DanhSachTaiSanCombo } from "../../../../constants/danhSachTaiSanConst";
import cauHinh from "utils/cauHinh";
import CauHinhApi from "../../../../service/cauHinhApi";
import choVayConst, {
  bindKieuLaiSuat,
  bindTypePaid,
} from "constants/choVayConst";
import NumberInput from "components/GenericComponent/NumberInput";
import NumberFormat from "react-number-format";

export const ThemMoiGoiVay = (props) => {
  const currentForm = useForm();
  const { control, setValue } = currentForm;
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchGoiVay);
  const initDataAddAndEditnew = {
    LoaiGoiVay: "TheChap",
    GoiVayId: 0,
    KyDongLaiLoai: "1",
    LaiSuatKieu: "1",
  };
  // const [defaultKyDongLaiLoai, setDefaultKyDongLaiLoai] = useState("");
  // const [defaultLaiSuatKieu, setDefaultLaiSuatKieu] = useState("");
  const [configCamDoTinChap, setConfigCamDoTinChap] = useState([]);
  const [configSys, setConfigSys] = useState({});
  const [bDisable, setDisableButton] = useState(false);
  const [dataAddAndEditNew, setDataAddAndEdit] = useState({});
  const [CachTinhLaiSuatCombo, setCachTinhLaiSuatCombo] = useState([]);
  const [loaiGoiVayCombo, setLoaiGoiVayCombo] = useState(
    DanhSachTaiSanCombo.LoaiGoiVayCombo,
  );

  const [isCauHinhQuyTrinhPheDuyet, setIsCauHinhQuyTrinhPheDuyet] =
    useState(false);
  const [sThoiHanVay, setThoiHanVay] = useState("");

  useEffect(() => {
    if (dataAddAndEditNew?.LaiSuat !== undefined) {
      setValue("LaiSuat", dataAddAndEditNew.LaiSuat);
    }
  }, [dataAddAndEditNew]);

  useEffect(() => {
    let data = { ...dataAddAndEditNew };
    console.log("dataAddAndEditNew", dataAddAndEditNew);
    if (typeof props.data.GoiVayId != "undefined" && props.data.GoiVayId > 0) {
      data = props.data;
      // setDataAddAndEdit(data);
      TinhThoiHanVay(data);
    } else {
      if (data.LoaiGoiVay != "TheChap" && data.LoaiGoiVay != "TinChap") {
        data.LoaiGoiVay = "TheChap";
        setDataAddAndEdit(data);
      }
    }
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        setConfigSys(response.data);
        if (response.data.length > 0) {
          const isCauHinhPheDuyet = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQuyTrinhPheDuyet.toUpperCase(),
          );
          if (isCauHinhPheDuyet != null) {
            if (isCauHinhPheDuyet.valueConfig === "1") {
              setIsCauHinhQuyTrinhPheDuyet(true);
            }
          }
        }
        const _kyDongLaiTinChapCamDoNgay = response.data.find(
          (e) => e.keyConfig === "_kyDongLaiTinChapCamDoNgay",
        );
        const _kyDongLaiTinChapCamDoThang = response.data.find(
          (e) => e.keyConfig === "_kyDongLaiTinChapCamDoThang",
        );
        const _kyDongLaiTinChapCamDoThangDinhKy = response.data.find(
          (e) => e.keyConfig === "_kyDongLaiTinChapCamDoThangDinhKy",
        );
        const _kyDongLaiTinChapCamDoTuan = response.data.find(
          (e) => e.keyConfig === "_kyDongLaiTinChapCamDoTuan",
        );

        const _laiTrieuNgayTinChapCamDoNgay = response.data.find(
          (e) => e.keyConfig === "_laiTrieuNgayTinChapCamDoNgay",
        );
        const _laiNgayTinChapCamDoNgay = response.data.find(
          (e) => e.keyConfig === "_laiNgayTinChapCamDoNgay",
        );
        const _laiThangTinChapCamDoNgay = response.data.find(
          (e) => e.keyConfig === "_laiThangTinChapCamDoNgay",
        );
        const _laiKyTinChapCamDoNgay = response.data.find(
          (e) => e.keyConfig === "_laiKyTinChapCamDoNgay",
        );
        const _laiPhanTramKyTinChapCamDoNgay = response.data.find(
          (e) => e.keyConfig === "_laiPhanTramKyTinChapCamDoNgay",
        );
        const _laiNgayTinChapCamDoThang = response.data.find(
          (e) => e.keyConfig === "_laiNgayTinChapCamDoThang",
        );
        const _laiTrieuNgayTinChapCamDoThang = response.data.find(
          (e) => e.keyConfig === "_laiTrieuNgayTinChapCamDoThang",
        );
        const _laiThangTinChapCamDoThang = response.data.find(
          (e) => e.keyConfig === "_laiThangTinChapCamDoThang",
        );
        const _laiTuanTinChapCamDoTuan = response.data.find(
          (e) => e.keyConfig === "_laiTuanTinChapCamDoTuan",
        );
        const _laiPhanTramTuanTinChapCamDoTuan = response.data.find(
          (e) => e.keyConfig === "_laiPhanTramTuanTinChapCamDoTuan",
        );
        const configCamDoTinChap = {
          _kyDongLaiTinChapCamDoNgay:
            _kyDongLaiTinChapCamDoNgay.valueConfig.toUpperCase() == "TRUE",
          _kyDongLaiTinChapCamDoThang:
            _kyDongLaiTinChapCamDoNgay.valueConfig.toUpperCase() == "TRUE",
          _kyDongLaiTinChapCamDoThangDinhKy:
            _kyDongLaiTinChapCamDoNgay.valueConfig.toUpperCase() == "TRUE",
          _kyDongLaiTinChapCamDoTuan:
            _kyDongLaiTinChapCamDoNgay.valueConfig.toUpperCase() == "TRUE",

          _laiTrieuNgayTinChapCamDoNgay:
            _laiTrieuNgayTinChapCamDoNgay.valueConfig.toUpperCase() == "TRUE",
          _laiNgayTinChapCamDoNgay:
            _laiNgayTinChapCamDoNgay.valueConfig.toUpperCase() == "TRUE",
          _laiThangTinChapCamDoNgay:
            _laiThangTinChapCamDoNgay.valueConfig.toUpperCase() == "TRUE",
          _laiKyTinChapCamDoNgay:
            _laiKyTinChapCamDoNgay.valueConfig.toUpperCase() == "TRUE",
          _laiPhanTramKyTinChapCamDoNgay:
            _laiPhanTramKyTinChapCamDoNgay.valueConfig.toUpperCase() == "TRUE",
          _laiNgayTinChapCamDoThang:
            _laiNgayTinChapCamDoThang.valueConfig.toUpperCase() == "TRUE",
          _laiTrieuNgayTinChapCamDoThang:
            _laiTrieuNgayTinChapCamDoThang.valueConfig.toUpperCase() == "TRUE",
          _laiThangTinChapCamDoThang:
            _laiThangTinChapCamDoThang.valueConfig.toUpperCase() == "TRUE",
          _laiTuanTinChapCamDoTuan:
            _laiTuanTinChapCamDoTuan.valueConfig.toUpperCase() == "TRUE",
          _laiPhanTramTuanTinChapCamDoTuan:
            _laiPhanTramTuanTinChapCamDoTuan.valueConfig.toUpperCase() ==
            "TRUE",
        };
        let loaiKyDong = bindTypePaid(configCamDoTinChap);
        let CachTinhLaiSuat = bindKieuLaiSuat(
          configCamDoTinChap,
          loaiKyDong[0].props.value,
        );
        if (
          typeof props.data.GoiVayId == "undefined" ||
          props.data.GoiVayId == 0
        ) {
          data.KyDongLaiLoai = loaiKyDong[0].props.value;
          data.LaiSuatKieu = CachTinhLaiSuat[0].props.value;
          setDataAddAndEdit(data);
        } else {
          CachTinhLaiSuat = bindKieuLaiSuat(
            configCamDoTinChap,
            data.KyDongLaiLoai,
          );
          setDataAddAndEdit(data);
        }

        setCachTinhLaiSuatCombo(CachTinhLaiSuat);
        setConfigCamDoTinChap(configCamDoTinChap);
      }
    });
  }, [dataAddAndEditNew.GoiVayId]);

  const updateTextValue = (field) => (e) => {
    const data = { ...dataAddAndEditNew };
    data[field] = e.target.value;
    setDataAddAndEdit(data);
    if (
      field == "KyDongLaiLoai" ||
      field == "SoLanTra" ||
      field == "KyDongLai"
    ) {
      TinhThoiHanVay(data);
    }
  };
  const TinhThoiHanVay = (data) => {
    if (
      typeof data.KyDongLai !== "undefined" &&
      typeof data.SoLanTra !== "undefined"
    ) {
      var TenKyDongLaiLoai = "";
      if (data.KyDongLaiLoai == "1") {
        TenKyDongLaiLoai = "ngày";
      } else if (data.KyDongLaiLoai == "4") {
        TenKyDongLaiLoai = "tuần";
      } else {
        TenKyDongLaiLoai = "tháng";
      }
      var ThoiHan = data.KyDongLai * data.SoLanTra + " " + TenKyDongLaiLoai;
      setThoiHanVay(ThoiHan);
    }
  };
  const onChangeKyDongLaiLoai = () => (evt) => {
    const data = { ...dataAddAndEditNew };
    data.KyDongLaiLoai = evt.target.value;
    setDataAddAndEdit(data);
    let CachTinhLaiSuat = bindKieuLaiSuat(
      configCamDoTinChap,
      data.KyDongLaiLoai,
    );
    setCachTinhLaiSuatCombo(CachTinhLaiSuat);
  };
  const onChangeLaiSuatLoai = () => (evt) => {
    const data = { ...dataAddAndEditNew };
    data.LaiSuatKieu = evt.target.value;
    setDataAddAndEdit(data);
  };

  const addOrEdit = () => {
    setDisableButton(true);
    dsGoiVayApi.addOrUpdate(dataAddAndEditNew).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        props.data.onSearch();
        setDataAddAndEdit(initDataAddAndEditnew);
        props.onHide();
        pushNotification("Thao tác thành công", "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response, "error", "TOP_CENTER", 2000);
      }
    });
  };
  let data = { ...dataAddAndEditNew };
  return (
    <Modal
      {...props}
      // backdrop={false}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal  text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-logo-quan-ly-thu-chi.png" />
          </span>{" "}
          {dataAddAndEditNew.GoiVayId > 0 ? "Sửa" : "Thêm mới"} gói vay
        </h4>

        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse196"
                className="card-header"
                href="#collapse196"
                aria-expanded="true"
                aria-controls="collapse196"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Thông tin</h3>
                </a>
              </div>
              <div
                id="collapse196"
                aria-labelledby="headingCollapse96"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="label-control color7-bold">
                            Mã gói vay
                          </label>
                          <input
                            type="text"
                            className="form-control input-sm"
                            value={dataAddAndEditNew.MaGoiVay}
                            onChange={updateTextValue("MaGoiVay")}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label className="label-control color7-bold">
                            Tên gói vay
                          </label>
                          <input
                            type="text"
                            className="form-control input-sm"
                            value={dataAddAndEditNew.TenGoiVay}
                            onChange={updateTextValue("TenGoiVay")}
                          />
                        </div>
                      </div>
                      {isCauHinhQuyTrinhPheDuyet == false && (
                        <>
                          <div className="col-md-4"></div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="label-control color7-bold">
                                Hạn mức gói vay
                              </label>
                              <NumberFormat
                                onChange={updateTextValue("HanMucGoiVay")}
                                className="form-control input-sm"
                                thousandSeparator
                                value={dataAddAndEditNew.HanMucGoiVay}
                              />
                            </div>
                          </div>
                        </>
                      )}
                      {isCauHinhQuyTrinhPheDuyet == true && (
                        <>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="label-control color7-bold">
                                Loại gói vay
                                <span className="canh-bao-red">*</span>
                              </label>
                              <select
                                class="form-control input-sm"
                                value={dataAddAndEditNew.LoaiGoiVay}
                                onChange={updateTextValue("LoaiGoiVay")}
                              >
                                {loaiGoiVayCombo &&
                                  loaiGoiVayCombo.map((item, idx) => (
                                    <option
                                      key={"combo" + idx}
                                      value={item.value}
                                    >
                                      {item.label}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="label-control color7-bold">
                                Hạn mức gói vay{" "}
                                {dataAddAndEditNew.LoaiGoiVay === "TheChap"
                                  ? "(%)"
                                  : "(VND)"}
                              </label>
                              <NumberFormat
                                onChange={updateTextValue("HanMucGoiVay")}
                                className="form-control input-sm"
                                thousandSeparator
                                value={dataAddAndEditNew.HanMucGoiVay}
                              />
                            </div>
                          </div>
                          <div className="col-md-12"></div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="label-control color7-bold">
                                Thời hạn vay
                              </label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={sThoiHanVay}
                                readOnly={true}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="label-control color7-bold">
                                Kỳ đóng lãi
                              </label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={dataAddAndEditNew.KyDongLai}
                                onChange={updateTextValue("KyDongLai")}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="label-control color7-bold">
                                Loại
                              </label>
                              <select
                                name="KyDongLaiLoai"
                                className="form-control input-sm"
                                onChange={onChangeKyDongLaiLoai()}
                                value={dataAddAndEditNew.KyDongLaiLoai}
                                defaultValue={dataAddAndEditNew.KyDongLaiLoai}
                              >
                                {bindTypePaid(configCamDoTinChap)}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="label-control color7-bold">
                                Số lần trả
                              </label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={dataAddAndEditNew.SoLanTra}
                                onChange={updateTextValue("SoLanTra")}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <NumberInput
                              labelClass="col-md-4 label-control"
                              inputClass="form-control input-sm"
                              inputWrapClass="col-md-12"
                              wrapperClass="form-group row"
                              starRed="*"
                              labelText={`Lãi suất`}
                              placeholder="10,000,000"
                              inputProps={{
                                name: "LaiSuat",
                                onChange: updateTextValue("LaiSuat"),
                                value: dataAddAndEditNew?.LaiSuat ?? "",
                                control: control,
                              }}
                            ></NumberInput>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="label-control color7-bold">
                                Cách tính
                              </label>
                              <select
                                name="LaiSuatKieu"
                                className="form-control input-sm"
                                onChange={onChangeLaiSuatLoai()}
                                value={dataAddAndEditNew.LaiSuatKieu}
                              >
                                {CachTinhLaiSuatCombo &&
                                  CachTinhLaiSuatCombo.map((item, idx) => (
                                    <option
                                      key={"combo" + idx}
                                      value={item.props.value}
                                    >
                                      {item.props.children}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="label-control color7-bold">
                                Ghi chú
                              </label>
                              <input
                                type="text"
                                className="form-control input-sm"
                                value={dataAddAndEditNew.GhiChu}
                                onChange={updateTextValue("GhiChu")}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          className="btn btn-new-main btn-checknew"
          onClick={addOrEdit}
          disabled={bDisable}
        >
          <span>
            <i class="mdi mdi-check"></i>
          </span>
          &nbsp; {dataAddAndEditNew.GoiVayId > 0 ? "Cập nhật" : "Thêm mới"}
          &nbsp;
        </button>
        &nbsp;
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i className="mdi mdi-close"></i>
          </span>{" "}
          &nbsp; Đóng&nbsp;
        </a>
      </Modal.Footer>
    </Modal>
  );
};
